export default "__VITE_ASSET__DLptaFNQ__"